import { ContainerProps as ContainerPropsUI } from '@mantine/core';
import classnames from 'classnames';
import { Wrapper } from './Container.style';

export type ContainerProps = ContainerPropsUI & {
  flex?: boolean;
};

export function Container(props: ContainerProps) {
  const { flex } = props;

  const className = classnames('Container-wrapper', {
    flex,
  });

  return (
    <Wrapper className={className} data-testid='Container-wrapper'>
      {props.children}
    </Wrapper>
  );
}

export default Container;
